import { CONTACT_EMAIL } from '@parlay-picker/shared/appConfig';
import type { ReactElement } from 'react';

type LegalDocType = 'terms' | 'privacy';

interface AuthPageFooterProps {
  onOpenLegalDoc: (type: LegalDocType) => void;
}

export function AuthPageFooter({ onOpenLegalDoc }: AuthPageFooterProps): ReactElement {
  return (
    <footer className="p-6 border-t border-gray-800 relative z-10 border-theme-border/30">
      <div className="mx-auto max-w-5xl">
        <div className="flex justify-center gap-6 mb-4 text-sm">
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-theme-text-tertiary hover:text-theme-text-secondary transition"
          >
            Contact
          </a>
          <a
            href="/faq"
            className="text-theme-text-tertiary hover:text-theme-text-secondary transition"
          >
            FAQ
          </a>
          <button
            type="button"
            onClick={() => onOpenLegalDoc('privacy')}
            className="text-theme-text-tertiary hover:text-theme-text-secondary transition"
          >
            Privacy
          </button>
          <button
            type="button"
            onClick={() => onOpenLegalDoc('terms')}
            className="text-theme-text-tertiary hover:text-theme-text-secondary transition"
          >
            Terms
          </button>
        </div>
        <p className="text-center text-gray-600 text-xs">
          Gamble responsibly. This is not financial advice.
        </p>
      </div>
    </footer>
  );
}
